<!--For managing design in the pages-->
<main class="main-wrap-ng" *ngIf="!addProductPopup">
  <div class="content-blk">
    <div class="container">
      <div align="center" id="embeddedDesigner"></div>
    </div>
  </div>
</main>

<!--For managing design in the popup-->
<div align="center" id="embeddedDesigner" *ngIf="addProductPopup"></div>


